import React, { useCallback } from "react";
import { Icon } from "@findemdev/maui";
import {
  ExtPromotor,
  CloseButton,
  ExtArtWrapper,
  SecondArt,
  SecondArtTextWrapper,
  TitleText,
  BelowText,
  LearnMoreLink,
  InstallButton,
} from "./ExtensionPromotion.styled";
import ExtensionArtwork from "../../../assets/images/Extension graphic-extended.png";
import { EXTENSION_URLS } from "../../../constants/urls";
import { APP_NAMES } from "../../../types/app";
import { getAppName } from "../../../utils/common";

const appName = getAppName();

interface ExtensionPromotionProps {
  className?: string;
  onClose?: () => void;
}

const ExtensionPromotion: React.FC<ExtensionPromotionProps> = ({
  className,
  onClose,
}) => {
  const handleInstallExtension = useCallback(() => {
    window.open(EXTENSION_URLS.CHROME_WEB_STORE, "_blank");
  }, []);

  const handleLearnMore = useCallback(() => {
    const learnMoreUrl = appName === APP_NAMES.RRA
      ? EXTENSION_URLS.LEARN_MORE_RRA
      : EXTENSION_URLS.LEARN_MORE_EXEC;
    window.open(learnMoreUrl, "_blank");
  }, []);

  return (
    <ExtPromotor className={className}>
      {onClose ? (
        <CloseButton
          type="button"
          aria-label="Dismiss extension promotion"
          onClick={onClose}
        >
          <Icon icon="close" $size={18} />
        </CloseButton>
      ) : null}
      <ExtArtWrapper backgroundImage={ExtensionArtwork} />
      <SecondArt>
        <SecondArtTextWrapper>
          <TitleText>Boost search power 🚀</TitleText>
          <BelowText>
            Install the Findem Extension for quick access while browsing and engaging with candidates.{" "}
            <LearnMoreLink as="a" onClick={handleLearnMore}>
              Learn more
            </LearnMoreLink>
          </BelowText>
        </SecondArtTextWrapper>
        <InstallButton type="primary" onClick={handleInstallExtension}>
          Install Extension <Icon icon="open_in_new" $size={16} />
        </InstallButton>
      </SecondArt>
    </ExtPromotor>
  );
};

export default ExtensionPromotion;
